const sliderHome = new Swiper('.slider-home', {
    // Optional parameters
    loop: true,
    // Navigation arrows
/*    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },*/
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
    },

});

const sliderRivolgiamo = new Swiper('.slider-a-chi', {
    //loop: true,
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 15,
   // centeredSlides: true,
});

function ScrollNav () {
    jQuery(document).scroll(function () {
        var $nav = jQuery(".navbar-fixed-top");
        var $logoGreen = jQuery(".logo-green");

        $nav.toggleClass('scrolled', jQuery(this).scrollTop() > $nav.height());
        $logoGreen.toggleClass('d-none', jQuery(this).scrollTop() < $nav.height());
    });
}



if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i)) {
   let nav = document.getElementById('main-nav');
    let logoGreen = document.getElementById('logo-green');

    nav.classList.toggle("scrolled");
    logoGreen.classList.toggle("d-none");
} else {
    ScrollNav();
}